import { always, cond } from "ramda";
import { PropsOrComponent } from "../modals/ModalTrigger";
import { isRootieComponent } from "./is-rootie-component";

export const propsOrComponent = <TProps>(elem: PropsOrComponent<TProps>, Component?: React.Component<TProps>) => cond([
  [isRootieComponent, (elem) => {
    const { Component, ...props} = elem;
    return { Component, props:{...props}};
  }],
  [(_)=>true, (props) => ({Component,props}) ]
])(elem);

